import React from 'react';
import { Check } from 'lucide-react';
import { whyChooseUs } from '../mock';

export const WhyChoose = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-[#0B7CB5]/5">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Why Choose <span className="text-[#0B7CB5]">Custom Maids RVA</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Experience the difference of working with Richmond's most trusted cleaning professionals
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {whyChooseUs.map((item, index) => (
            <div
              key={index}
              className="flex items-start space-x-4 bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group"
            >
              <div className="flex-shrink-0">
                <div className="w-10 h-10 bg-[#0B7CB5]/10 rounded-full flex items-center justify-center group-hover:bg-[#0B7CB5] transition-colors duration-300">
                  <Check className="w-6 h-6 text-[#0B7CB5] group-hover:text-white transition-colors duration-300" />
                </div>
              </div>
              <p className="text-gray-800 font-medium text-lg leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};